/**
 * Uygulama genelinde servis kaydı ve çözümlemesi.
 */
export class ServiceRegistry {
  private readonly services = new Map<symbol, unknown>();

  register<T>(token: symbol, instance: T): void {
    this.services.set(token, instance);
  }

  get<T>(token: symbol): T {
    const service = this.services.get(token);
    if (service === undefined) {
      throw new Error(`Service not registered: ${String(token)}`);
    }
    return service as T;
  }

  tryGet<T>(token: symbol): T | undefined {
    return this.services.get(token) as T | undefined;
  }

  clear(): void {
    this.services.clear();
  }
}

/** DI token'ları */
export const ServiceTokens = {
  gameManager: Symbol('GameManager'),
  uiManager: Symbol('UIManager'),
  audioManager: Symbol('AudioManager'),
  apiManager: Symbol('ApiManager'),
  leaderboardManager: Symbol('LeaderboardManager'),
  saveManager: Symbol('SaveManager'),
  adManager: Symbol('AdManager'),
  localization: Symbol('LocalizationService'),
  eventBus: Symbol('EventBus'),
} as const;
